module.exports = "../../../../platform/assets/pageMainIcon/simple_jichudanganlei3.svg";